export function getMetaData(name: string, doc: Document): string {
    const element = doc.querySelector(`meta[name="${name}"]`);

    if (!element) {
        return '';
    }

    return element.getAttribute('content') || '';
}

export function getMonsAppName(doc: Document): string {
    return getMetaData('a2z:mons_app_name', doc);
}

export function getMonsSiteName(doc: Document): string {
    return getMetaData('a2z:mons_site_name', doc);
}

export function getCsrfToken(doc: Document): string {
    return getMetaData('anti-csrftoken-a2z', doc);
}

export function getUrl() {
    const location = window.parent.location;
    return `${location.protocol}//${location.host}${location.pathname}`;
}

export function getRequestId() {
    const reqTag = window.parent.document.querySelector( 'meta[name="a2z:request_id"]');

    if (!reqTag) {
        return '';
    }

    return reqTag.getAttribute('content') || '';
}

export function getVibesTreatment(doc: Document): string {
    //TODO: Clean this up to remove the getMetaData call when SC deploys the corresponding change
    const metaInfo = "a2z:vibesTreatment";
    const inputElement = doc.getElementById(metaInfo);
    if (inputElement) {
        return inputElement.getAttribute("value") || "";
    }
    return getMetaData(metaInfo, doc);
}